<template>
  <div class="error-notification-wrapper">
    <!-- This component is used for enhanced error styling -->
  </div>
</template>

<script>
export default {
  name: 'ErrorNotification'
}
</script>

<style>
/* Enhanced Error Notification Styles */
.error-notification {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  padding: 16px 20px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

.error-notification--error {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%) !important;
  color: white !important;
}

.error-notification--warning {
  background: linear-gradient(135deg, #ffa726 0%, #ff9800 100%) !important;
  color: white !important;
}

.error-notification--success {
  background: linear-gradient(135deg, #66bb6a 0%, #4caf50 100%) !important;
  color: white !important;
}

.error-notification--info {
  background: linear-gradient(135deg, #42a5f5 0%, #2196f3 100%) !important;
  color: white !important;
}

/* Error Dialog Styles */
.error-dialog {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.error-dialog--error .el-message-box__header {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%) !important;
  color: white !important;
}

.error-dialog--warning .el-message-box__header {
  background: linear-gradient(135deg, #ffa726 0%, #ff9800 100%) !important;
  color: white !important;
}

.error-dialog-content {
  text-align: center;
  padding: 20px 0;
}

.error-dialog-icon {
  display: block;
  margin: 0 auto 16px;
  font-size: 48px;
  color: #f56c6c;
}

.error-dialog--warning .error-dialog-icon {
  color: #e6a23c;
}

.error-dialog-message {
  font-size: 16px;
  line-height: 1.6;
  color: #606266;
  margin-top: 16px;
}

/* Enhanced Button Styles */
.error-dialog .el-button--danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%) !important;
  border: none !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.error-dialog .el-button--danger:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(255, 107, 107, 0.3) !important;
}

.error-dialog .el-button--warning {
  background: linear-gradient(135deg, #ffa726 0%, #ff9800 100%) !important;
  border: none !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.error-dialog .el-button--warning:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 8px rgba(255, 167, 38, 0.3) !important;
}

/* Animation for notifications */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.error-notification {
  animation: slideInRight 0.3s ease-out !important;
}

/* Responsive design */
@media (max-width: 768px) {
  .error-notification {
    margin: 10px !important;
    border-radius: 6px !important;
  }

  .error-dialog {
    margin: 20px !important;
    border-radius: 8px !important;
  }

  .error-dialog-content {
    padding: 16px 0;
  }

  .error-dialog-icon {
    font-size: 36px;
  }

  .error-dialog-message {
    font-size: 14px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .error-dialog-message {
    color: #e0e0e0;
  }

  .error-dialog {
    background: #2d3748 !important;
    color: #e0e0e0 !important;
  }
}
</style>
